import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import BM10110View from "../../Views/Bases/BM10110";
import Snackbar from "../../Components/Snackbar";

function BM10110(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [inputs, setInputs] = React.useState({
    comboBarcode: [], //바코드
    comboValue: "",
  });
  const [checkInputs, setCheckInputs] = React.useState({
    processCd: "PRO003",
    processNm: "",
    machineCd: "",
    comboProcessCd: [],
    result: false,
  });
  const [saveData, setSaveData] = React.useState([]);

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (
        e.message === "ResizeObserver loop limit exceeded" ||
        e.message ===
          "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let getComboData = [];
    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      //콤보박스
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetCode,
        {
          groupCd: "string",
        }
      ).then((result) => {
        let data = result.data;
        for (let i = 0; i < data.length; i++) {
          getComboData.push({
            ip: data[i].Ref1,
            port: data[i].Ref2,
            groupCd: data[i].GroupCd,
            value: data[i].Code,
            name: data[i].Name,
          });
        }
      });

      inputs.comboBarcode = getComboData.filter(
        (e) => e.groupCd == "BARCODE_LOCATION" && e.value != "BARCODE_LOCATION"
      );
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Bases.BM10110.GetCommunication
      ).then((result) => {
        let data = result.data;
        if (data == "데이터가 없습니다.") {
          setRowData([]);
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              userId: data[i].userId,
              userNm: data[i].userNm,
              barcodeLocation: data[i].barcodeLocation,
              barcodeLocationNm: data[i].barcodeLocationNm,
              ip: data[i].ip,
              port: data[i].port,
              createDate: data[i].createDate
                ? Commons.DateFormating(data[i].createDate.toString(), 2)
                : "",
              createId: data[i].createId,
              updateDate: data[i].updateDate
                ? Commons.DateFormating(data[i].updateDate.toString(), 2)
                : "",
              updateId: data[i].updateId,
            });
          }
          setRowData(getRowData);
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const SaveConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        SaveLogic();
      }
    );
  };

  const SaveLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let updateData = Commons.Deduplication(changedRowData);
    let getData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });

      for (let i = 0; i < updateData.length; i++) {
        if (updateData[i].barcodeLocationNm == null) {
          throw new Error("바코드위치를 선택하세요.");
        }
        getData.push({
          userId: updateData[i].userId,
          barcodeLocation: updateData[i].barcodeLocationNm.value,
          ip: updateData[i].ip,
          port: updateData[i].port,
        });
      }
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10110.Create,
        getData
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          throw new Error(data.message);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
      setChangedRowData([]);
    }
  };

  return (
    <>
      <BM10110View
        Init={Init}
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        setSelectedRowData={setSelectedRowData}
        SaveConfirm={SaveConfirm}
        inputs={inputs}
        setInputs={setInputs}
        checkInputs={checkInputs}
        setCheckInputs={setCheckInputs}
        setSnackbars={setSnackbars}
        setSaveData={setSaveData}
        saveData={saveData}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default BM10110;
